import * as React from 'react'

import { Filter } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../../../app/_providers/TranslationProvider.client'
import { useCollectionFilterQueryParamsContext } from '../../../../../../../../brunswick/containers/CollectionFilterQueryParamsContext'
import { useHeapAttributes } from '../../../../../../../../containers/HeapAttributesContainer'
import { trackEvent } from '../../../../../../../../lib/analytics'
import { ColumnActions } from '../../ColumnActions'
import { useCollectionFiltersContext } from '../../containers/CollectionFiltersContext'
import { ColumnLayoutService } from '../../containers/ColumnLayoutService'
import { FilterModalService } from '../../containers/FilterModalService'
import { textWithFilterCount } from '../../utils'

import {
  ActionButton,
  Actions,
  FilterActions,
  FilterIconWrap,
  FilterLabel,
  TotalWrap,
} from './styles'

export const MobileFilterPanel = () => {
  const analyticsContext = useHeapAttributes()
  const { totalItemsCount, filters } = useCollectionFiltersContext()
  const hasFilters = filters && filters.length > 0

  const {
    collections: {
      filtering: { mobileFilterPanel: mobileFilterPanelCopy },
    },
  } = useTranslation()
  const { numberOfColumnsOnMobile, setNumberOfColumnsOnMobile } = ColumnLayoutService.useContainer()
  const { openFilterModal } = FilterModalService.useContainer()

  const { totalNumberOfSelectedFilterValues } = useCollectionFilterQueryParamsContext()

  const analyticAttributes = trackEvent({
    category: `${analyticsContext.category} filters`,
    action: 'click',
    label: 'open',
    value: mobileFilterPanelCopy.filterCta,
  })

  return (
    <>
      <Actions>
        {hasFilters ? (
          <FilterActions>
            <ActionButton
              onClick={openFilterModal}
              variant={'black-on-white'}
              {...analyticAttributes}
            >
              <FilterIconWrap>
                <Filter />
              </FilterIconWrap>
              <FilterLabel>
                {textWithFilterCount(
                  mobileFilterPanelCopy.filterCta,
                  totalNumberOfSelectedFilterValues
                )}
              </FilterLabel>
            </ActionButton>
          </FilterActions>
        ) : null}
        <TotalWrap>{totalItemsCount} Total</TotalWrap>
        <ColumnActions
          numberOfColumnsOnMobile={numberOfColumnsOnMobile}
          setNumberOfColumnsOnMobile={setNumberOfColumnsOnMobile}
        />
      </Actions>
    </>
  )
}
